import { z } from 'zod';

/**
 * Schéma de validation pour le formulaire de leçon
 */
export const lessonFormSchema = z.object({
  title: z.string().min(1, 'Le titre est requis').max(255),
  description: z.string().optional(),
  typeId: z.string().uuid('Le type doit être un UUID valide'),
  duration: z
    .number()
    .int('La durée doit être un nombre entier')
    .min(15, 'La durée doit être au moins 15 minutes')
    .max(480, 'La durée ne peut pas dépasser 480 minutes'),
  chapterId: z
    .string()
    .min(1, 'Le chapitre est requis')
    .uuid('Le chapitre doit être un UUID valide'),
  statusId: z.string().uuid('Le statut doit être un UUID valide'),
  // Remplis automatiquement depuis le chapitre (create uniquement)
  subjectExternalId: z.string().uuid('La matière est requise').optional(),
  levelExternalId: z.string().uuid('Le niveau est requis').optional(),
  programConceptIds: z.array(z.string().uuid()).optional(),
});

export type LessonFormData = z.infer<typeof lessonFormSchema>;
